module.exports = __webpack_public_path__ + "img/hint.60ef29a3.png";